import { useState, useEffect } from 'react';
import '../assets/css/module-count.css';
import { useCountUp } from '../hooks/useCountUp';
import { getCountData } from '../utils/notionClient';

import { ReactComponent as Count1 } from '../assets/images/icon-count-01.svg'
import { ReactComponent as Count2 } from '../assets/images/icon-count-02.svg'
import { ReactComponent as Count3 } from '../assets/images/icon-count-03.svg'
import { ReactComponent as Count4 } from '../assets/images/icon-count-04.svg'


export default function Count() {
    const [counts, setCounts] = useState({
        total_people: 0,
        total_count: 0,
        total_center: 0,
        total_store: 0,
        date: '',
        special_donation: ''
    });
    const [loading, setLoading] = useState(true);

    // 숫자 데이터를 정수로 변환
    const animatedPeople = useCountUp(Number(counts.total_people));
    const animatedCount = useCountUp(Number(counts.total_count));
    const animatedCenter = useCountUp(Number(counts.total_center));
    const animatedStore = useCountUp(Number(counts.total_store));

    useEffect(() => {
        const fetchCounts = async () => {
            try {
                const data = await getCountData();
                
                // 데이터를 숫자로 변환하여 저장
                setCounts({
                    total_people: Number(data.total_people),
                    total_count: Number(data.total_count),
                    total_center: Number(data.total_center),
                    total_store: Number(data.total_store),
                    date: data.date,
                    special_donation: data.special_donation
                });
            } catch (error) {
                console.error('Failed to fetch counts:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchCounts();
    }, []);

    if (loading) {
        return <div className="loading">로딩 중...</div>;
    }


    return (
        <div>
            <div id='count-module' className='inner flex flex-wrap text-center'>
                <div>
                    <div><Count1 /></div>
                    <h5>함께한<br/>어르신</h5>
                    <p className="emphasis"><b>{animatedPeople}</b>명</p>
                </div>
                <div>
                    <div><Count2 /></div>
                    <h5>본죽<br/>나눔 수량</h5>
                    <p className="emphasis"><b>{animatedCount}</b>그릇</p>
                </div>
                <div>
                    <div><Count3 /></div>
                    <h5>함께한<br/>복지기관</h5>
                    <p className="emphasis"><b>{animatedCenter}</b>개소</p>
                </div>
                <div>
                    <div><Count4 /></div>
                    <h5>함께한 가맹점<br/>본죽, 본죽&비빔밥</h5>
                    <p className="emphasis"><b>{animatedStore}</b>개</p>
                </div>
            </div>
            <div className="count-date">
                <small>{counts.date} 기준</small>
            </div>
        </div>
    );
  };
  